//React
import { FunctionComponent, useEffect, useState } from "react";

//App Hooks
import {
	useAppDispatch,
	useAppSelector,
} from "../../../system/redux/hooks/redux-store-hooks";

//Actions
import { setCurrentUnmatchedPage } from "../../redux/slices/result-list-slice";

//Selectors
import { selectCurrentUnmatchedPage } from "../../redux/selectors/pagination/select-current-unmatched-page";
import { selectUnmatchedResults } from "../../redux/selectors/facets/select-unmatched-results";

/** Outputs the  links for the currently selected results that DO NOT match the current facet selection. */
const ResultLoadMorePager: FunctionComponent = (props) => {
	//Store Dispatch
	const dispatch = useAppDispatch();

	//State Values
	const currentUnmatchedPage = useAppSelector(selectCurrentUnmatchedPage);
	const totalUnmatchedResultsCount = useAppSelector(
		selectUnmatchedResults,
	)?.length;

	const [showLoadMoreLink, setShowLoadMoreLink] = useState<boolean>(true);

	//Use Effects
	useEffect(() => {
		//If all the unmatched results are shown already do not show the load more link.
		if (totalUnmatchedResultsCount <= currentUnmatchedPage * 10) {
			setShowLoadMoreLink(false);
		}
	}, [currentUnmatchedPage]);

	if (!showLoadMoreLink) {
		return null;
	}

	//JSX
	return (
		<button
			className="other-nearby-load"
			style={{ borderBottom: "1px solid black" }}
			type="button"
			onClick={() => {
				dispatch(setCurrentUnmatchedPage(currentUnmatchedPage + 1));
			}}
		>
			+ Load more
		</button>
	);
};

export default ResultLoadMorePager;
